import React, { useCallback } from "react";

import AddIcon from "@mui/icons-material/Add";
import FormDialog from "../../../../components/Dialog/FormDialog";
import InviteUserForm from "./InviteUserForm";
import { useResponsive } from "../../../../hooks/useResponsive";
import { CustomButton } from "../../../../components/Button/Button";

function InviteUser() {
  const [openInviteUserDialog, setOpenInviteUserDialog] = React.useState(false);
  const isMobile = useResponsive("down", "md");

  const handleClickOpen = useCallback(() => {
    setOpenInviteUserDialog(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpenInviteUserDialog(false);
  },[]);
  
  return (
    <div className="mr-2">
      {openInviteUserDialog && (
        <FormDialog
          open={openInviteUserDialog}
          handleClose={handleClose}
          title={"Invite User"}
          btnTitle={"Add"}
          fullWidth={true}
        >
          <InviteUserForm onClose={handleClose} />
        </FormDialog>
      )}
      <CustomButton
        onClick={handleClickOpen}
        className="capitalize orange-color invite-user-button"
        variant="contained"
        startIcon={<AddIcon />}
      >
        Invite User
      </CustomButton>
    </div>
  );
}

export default React.memo(InviteUser);
